import { render } from "./RegistrationStepper.vue?vue&type=template&id=32fd56e2&scoped=true"
import script from "./RegistrationStepper.vue?vue&type=script&lang=js"
export * from "./RegistrationStepper.vue?vue&type=script&lang=js"

import "./RegistrationStepper.vue?vue&type=style&index=0&id=32fd56e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fd56e2"]])

export default __exports__